module.exports = __webpack_public_path__ + "img/small_screen.b39188bd.svg";